import script from "./SvgImage.vue?vue&type=script&lang=js"
export * from "./SvgImage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__